// extracted by mini-css-extract-plugin
module.exports = {"adventureBook":"styles_adventureBook__1vGnn","listWrapper":"styles_listWrapper__1PJ24","mapWrapper":"styles_mapWrapper__1VIx7"};